import React from 'react';
import styles from './date-range-button.module.scss';

interface DateRangeButtonProps {
  selectedLabel?: string;
  onClick: () => void;
  className?: string;
  icon?: React.ReactNode;
}

export const DateRangeButton: React.FC<DateRangeButtonProps> = ({
  selectedLabel = 'Select Range',
  onClick,
  className = '',
  icon,
}) => {
  return (
    <button className={`${styles.rangeButton} ${className}`} onClick={onClick}>
      <span className={styles.label}>{selectedLabel}</span>
      {icon ? (
        <span className={styles.customIcon}>{icon}</span>
      ) : (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M6.66667 1.66667V4.16667M13.3333 1.66667V4.16667M2.5 16.6667V6.66667C2.5 6.00363 2.76339 5.36774 3.23223 4.8989C3.70107 4.43006 4.33696 4.16667 5 4.16667H15C15.663 4.16667 16.2989 4.43006 16.7678 4.8989C17.2366 5.36774 17.5 6.00363 17.5 6.66667V16.6667M2.5 16.6667C2.5 17.3297 2.76339 17.9656 3.23223 18.4345C3.70107 18.9033 4.33696 19.1667 5 19.1667H15C15.663 19.1667 16.2989 18.9033 16.7678 18.4345C17.2366 17.9656 17.5 17.3297 17.5 16.6667M2.5 16.6667V10C2.5 9.33696 2.76339 8.70107 3.23223 8.23223C3.70107 7.76339 4.33696 7.5 5 7.5H15C15.663 7.5 16.2989 7.76339 16.7678 8.23223C17.2366 8.70107 17.5 9.33696 17.5 10V16.6667"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="var(--app-landing-orange)"
          />
        </svg>
      )}
    </button>
  );
};
